export default {
  FlightAirlineOperator__AIRLINE_OPERATOR: (airlineName) => `Operated by: ${airlineName}`,
};
